import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Sparkles, Target, Clock, CheckCircle } from 'lucide-react';

/**
 * Componente reutilizable para mostrar ejemplos expandibles
 * @param {Object} examples - Datos de ejemplos desde exampleTemplates.json
 * @param {Function} onSelectExample - Callback cuando usuario selecciona un ejemplo
 */
const ExampleTemplates = ({ examples, onSelectExample = null }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  console.log('📦 [ExampleTemplates] Received examples:', examples);
  console.log('📦 [ExampleTemplates] Examples structure:', examples?.examples);

  if (!examples || !examples.examples) {
    console.log('❌ [ExampleTemplates] No valid examples data, returning null');
    return null;
  }

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSelectExample = (example) => {
    if (onSelectExample) {
      onSelectExample(example);
    }
  };

  return (
    <div className="mt-3">
      {/* Botón minimalista para expandir */}
      <button
        onClick={handleToggle}
        className="flex items-center gap-2 text-xs font-medium text-blue-600 hover:text-blue-800 transition-colors group"
      >
        <Sparkles className="w-3.5 h-3.5" />
        <span>{examples.title || 'Ver ejemplos'}</span>
        {isExpanded ? (
          <ChevronUp className="w-3.5 h-3.5 group-hover:translate-y-[-1px] transition-transform" />
        ) : (
          <ChevronDown className="w-3.5 h-3.5 group-hover:translate-y-[1px] transition-transform" />
        )}
      </button>

      {/* Contenedor expandible */}
      {isExpanded && (
        <div className="mt-3 bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 space-y-4 animate-in slide-in-from-top-2 duration-200">
          {examples.subtitle && (
            <p className="text-xs text-blue-700 font-medium">{examples.subtitle}</p>
          )}
          
          <div className="grid gap-3">
            {examples.examples.map((example, index) => (
              <div 
                key={example.id}
                className="bg-white border border-blue-200 rounded-lg p-3 hover:border-blue-300 hover:shadow-sm transition-all group"
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="font-semibold text-gray-900 text-sm">{example.titulo}</h4>
                      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                        {example.industria}
                      </span>
                    </div>
                    <p className="text-xs text-gray-600 mb-2 italic">"{example.hipotesis_base}"</p>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                    <Clock className="w-3 h-3" />
                    {example.tiempo_estimado}
                  </div>
                </div>
                
                <p className="text-xs text-gray-700 mb-3 leading-relaxed">{example.mvp_descripcion}</p>
                
                <div className="flex items-center justify-between text-xs">
                  <div className="flex items-center gap-1 text-purple-600">
                    <Target className="w-3 h-3" />
                    <span className="font-medium">Valida:</span>
                    <span>{example.validacion_clave}</span>
                  </div>
                  
                  {onSelectExample && (
                    <button
                      onClick={() => handleSelectExample(example)}
                      className="flex items-center gap-1 px-2 py-1 text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded transition-colors"
                    >
                      <CheckCircle className="w-3 h-3" />
                      Usar como base
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
          
          <div className="pt-2 border-t border-blue-200 text-xs text-blue-600">
            💡 <strong>Tip:</strong> Adapta estos ejemplos a tu industria y contexto específico
          </div>
        </div>
      )}
    </div>
  );
};

export default ExampleTemplates;